import React, { useState } from "react";
import styled from "styled-components";
import { rem } from "polished";
import PropTypes from "prop-types";
import { InputLabel } from "../UI/InputWrapper";

import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";

const StyledInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const StyledPhoneInput = styled(PhoneInput)`
  opacity: ${(props) => (props.disabled ? "0.3" : "1")};

  .PhoneInputCountry {
    border: ${rem("1px")} solid #cbcbcb;
    box-shadow: 0px ${rem("1px")} ${rem("10px")} #0000000d;
    border-radius: ${rem("2px")};
    padding: ${rem("10px")} ${rem("15px")};
    margin-right: ${rem("12px")};

    .PhoneInputCountrySelect:focus
      + .PhoneInputCountryIcon
      + .PhoneInputCountrySelectArrow {
      color: #707070;
    }

    .PhoneInputCountryIcon {
      box-shadow: none;
      position: relative;
      .PhoneInputCountryIconImg {
        position: absolute;
        top: 0;
        left: 0;
      }
    }
    .PhoneInputCountrySelectArrow {
      color: #707070;
      width: 11px;
      height: 11px;
      opacity: 1;
      margin-left: 11px;
      margin-bottom: 5px;
    }
  }
  input {
    font-family: ${({ theme }) => theme.secondaryFont};
    ${({ theme }) => theme.FontWithLineHeight("16px")};
    font-weight: 400;
    color: #343638;
    padding: ${rem("10px")} ${rem("15px")};
    border: ${rem("1px")} solid #cbcbcb;
    box-shadow: 0px ${rem("1px")} ${rem("10px")} #0000000d;
    border-radius: ${rem("2px")};
    background: #fff;

    &:focus {
      outline-color: ${({ theme }) => theme.primaryColor};
    }

    ${({ theme }) => theme.mobileL`
        ${({ theme }) => theme.FontWithLineHeight("14px")};
    `}
  }
`;

const PhoneNumberInput = ({
  placeholder,
  onChange,
  label,
  defaultValue,
  disabled,
  isErrorLabel,
}) => {
  const [value, setValue] = useState(defaultValue ? defaultValue : "");
  return (
    <StyledInputWrapper>
      <InputLabel
        htmlFor="phone-number"
        disabled={disabled}
        isErrorLabel={isErrorLabel}
      >
        {label}
      </InputLabel>
      <StyledPhoneInput
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        disabled={disabled}
        international
        defaultCountry="US"
      />
    </StyledInputWrapper>
  );
};

PhoneNumberInput.propTypes = {
  /**
   * Specify the state of the header
   */
  label: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  defaultValue: PropTypes.string,
  disabled: PropTypes.bool,
};

PhoneNumberInput.defaultProps = {
  label: "Guest Phone Number",
  disabled: false,
};

export default PhoneNumberInput;
